export default "__VITE_ASSET__5fb848c0__"